export default {
  items: [
    {
      name: 'Dashboard',
      url: '/user-dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Menu',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Forms',
      url: '/forms',
      icon: 'icon-briefcase',
      children: [
        {
          name: 'Admin Letters',
          url: '/forms/admin-letters',
          icon: 'icon-doc'
        },
        {
          name: 'Air Movement',
          url: '/forms/air-movement',
          icon: 'icon-doc'
        },
        {
          name: 'Land Movement',
          url: '/forms/land-movement',
          icon: 'icon-doc'
        },
        {
          name: 'Sea Movement',
          url: '/forms/sea-movement',
          icon: 'icon-doc'
        },
        {
          name: 'No Strike List',
          url: '/forms/no-strike-list',
          icon: 'icon-doc'
        },
        {
          name: 'Temporary Venue',
          url: '/forms/temp-venue',
          icon: 'icon-doc'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js